"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = require("lodash");
const utils_1 = require("./utils");
const app_info_1 = require("./app-info");
/**
 * General http request wrapper.  Automatically deserializes json and response text body.  Fails promise on 4xx and 5xx status codes.
 */
class Http {
    constructor(http, requestTimeoutProvider, params = {}) {
        this.http = http;
        this.requestTimeoutProvider = requestTimeoutProvider;
        this.appInfo = params.appInfo || new app_info_1.AppInfo({});
    }
    /**
     * Make an HTTP request with the GET verb
     * @param {HttpMethodRequest} params request parameters
     */
    get(params) {
        return this.request(Object.assign({ method: 'GET' }, params));
    }
    /**
     * Make an HTTP request with the POST verb
     * @param {HttpMethodRequest} params request parameters
     */
    post(params) {
        return this.request(Object.assign({ method: 'POST' }, params));
    }
    /**
     * Make an HTTP request with the PUT verb
     * @param {HttpMethodRequest} params request parameters
     */
    put(params) {
        return this.request(Object.assign({ method: 'PUT' }, params));
    }
    /**
     * Make an HTTP request with the DELETE verb
     * @param {HttpMethodRequest} params request parameters
     */
    delete(params) {
        return this.request(Object.assign({ method: 'DELETE' }, params));
    }
    request(request) {
        return __awaiter(this, void 0, void 0, function* () {
            request.headers = Object.assign({
                [Http.contentTypeHeader]: Http.jsonContent,
                [Http.connectionHeader]: 'keep-alive',
            }, this.appInfo.getAppHeaders(), request.headers);
            if (request.headers[Http.contentTypeHeader] === Http.jsonContent && typeof request.body !== 'string') {
                request.body = JSON.stringify(request.body);
            }
            const fetchResponse = yield utils_1.Utils.timeout(this.requestTimeoutProvider(request.timeoutMilliseconds), this.http.fetch(request.url, {
                method: request.method,
                headers: request.headers,
                body: request.body
            }));
            const responseHeaders = this.extractHeaders(fetchResponse);
            const httpResponse = {
                statusCode: fetchResponse.status,
                headers: responseHeaders,
                body: yield this.getBodyFromResponse(fetchResponse, responseHeaders[Http.contentTypeHeader]),
            };
            if (httpResponse.statusCode < 400) {
                return httpResponse;
            }
            else {
                throw httpResponse;
            }
        });
    }
    getBodyFromResponse(response, contentType) {
        return __awaiter(this, void 0, void 0, function* () {
            if (response.status != 204 && Http.textContentTypes.find(type => _.startsWith(contentType, type))) {
                const textBody = yield response.text();
                if (_.startsWith(contentType, Http.jsonContent)) {
                    try {
                        return JSON.parse(textBody);
                    }
                    catch (_a) {
                        // application can decide what to do when content-type is WRONG.
                    }
                }
                return textBody;
            }
            else {
                return response.body;
            }
        });
    }
    extractHeaders(response) {
        const headers = {};
        response.headers.forEach((value, name) => {
            headers[name] = value;
        });
        return headers;
    }
}
exports.Http = Http;
Http.contentTypeHeader = 'content-type';
Http.connectionHeader = 'connection';
Http.jsonContent = 'application/json';
Http.textContentTypes = [
    Http.jsonContent,
    'application/xml',
    'text/css',
    'text/html',
    'text/csv',
    'text/plain',
];
//# sourceMappingURL=http.js.map